// ========= START: src/components/GamePlayScreen.js (COMPLETE REPLACEMENT) =========
import React, { useEffect } from 'react';
import RunnerScene from './runner/RunnerScene';

function GamePlayScreen({
  score,
  wordList,
  currentWordIndex,
  isGameActive,
  resultImage, // Can be 'correct', 'incorrect', or 'perfect'
  statusMessage,
  speed,
  onMicPress,
  onGiveUp,
}) {
  if (wordList.length === 0 || !wordList[currentWordIndex]) {
    return <div className="game-play-screen"><h2 className="loading-text">Loading Round...</h2></div>;
  }

  const currentWord = wordList[currentWordIndex];

  // Logic to disable skip button if it's the last word
  const pendingWordsCount = wordList.filter(word => word.status === 'pending' || word.status === 'skipped').length;
  const isSkipDisabled = pendingWordsCount <= 1;

  return (
    <div className="game-play-screen">
      <div className="game-header">
        <p className="game-score-text">Score: {score}</p>
        <p className="game-word-count-text">{currentWordIndex + 1} / {wordList.length}</p>
      </div>

      <RunnerScene
        wordList={wordList}
        currentWordIndex={currentWordIndex}
        result={resultImage}
        isGameActive={isGameActive}
        speed={speed}
        onReachPlayer={() => {
          // Wall hit player - could add a camera shake or sound
        }}
        onShatterComplete={() => {
          if (resultImage === 'correct' || resultImage === 'perfect') {
            // The shell component PronunciationChallenge handles navigation
            // We just wait for the animation to finish
          }
        }}
      />

      <div className="result-feedback-overlay">
        {resultImage && (
          <img
            src={`${process.env.PUBLIC_URL}/assets/menu-buttons/${resultImage}.png`}
            alt={resultImage}
            className="result-feedback-image-3d"
          />
        )}
      </div>

      <div className="game-controls-footer">
        <div className="game-mic-container">
          <p className="game-status-text">{statusMessage}</p>

          {!isGameActive && (
            <button
              className='mic-button'
              onClick={onMicPress}
              style={{ pointerEvents: 'auto' }}
            >
              <img src={`${process.env.PUBLIC_URL}/assets/menu-buttons/go.png`} alt="Start Game" />
            </button>
          )}

          <p className="recognized-text">&nbsp;</p>
        </div>

        <div className="skip-buttons-container">
          <button
            className="game-button skip-button"
            onClick={onGiveUp}
            disabled={isSkipDisabled}
            style={{ pointerEvents: 'auto' }}
          >
            <img src={`${process.env.PUBLIC_URL}/assets/menu-buttons/skip.png`} alt="Skip" />
          </button>
        </div>
      </div>
    </div>
  );
}

export default GamePlayScreen;
// ========= END: src/components/GamePlayScreen.js (COMPLETE REPLACEMENT) =========